<template>
  <div class="distributors">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>供货商管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">添加供货商</el-button>
      </div>

      <div class="search-bar">
        <el-input
          v-model="query.title"
          placeholder="搜索供货商名称/联系人/手机号"
          prefix-icon="el-icon-search"
          size="small"
          style="width: 280px;"
          clearable
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="query.status" placeholder="状态（全部）" size="small" style="width: 140px;" clearable>
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
        <el-button type="danger" size="small" @click="handleSearch">搜索</el-button>
        <el-button size="small" @click="resetFilter">重置</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="供货商名称" min-width="180" />
        <el-table-column prop="contact_name" label="联系人" width="100">
          <template slot-scope="scope">{{ scope.row.contact_name || '-' }}</template>
        </el-table-column>
        <el-table-column prop="contact_phone" label="联系电话" width="120" />
        <el-table-column prop="wechat_merchant_no" label="分账商户号" width="150">
          <template slot-scope="scope">{{ scope.row.wechat_merchant_no || '-' }}</template>
        </el-table-column>
        <el-table-column prop="wechat_merchant_name" label="商户全称" min-width="180">
          <template slot-scope="scope">{{ scope.row.wechat_merchant_name || '-' }}</template>
        </el-table-column>
        <el-table-column label="可分账" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.can_profit_sharing ? 'success' : 'info'">
              {{ scope.row.can_profit_sharing ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="goods_count" label="商品数" width="80" />
        <el-table-column prop="admin_count" label="后台账号" width="90" />
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status === 1"
              @change="val => handleToggleStatus(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="170" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openAdmins(scope.row)">账号</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #E4393C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap" v-if="total > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
        />
      </div>
    </el-card>

    <!-- 添加/编辑供货商 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="供货商名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入供货商名称" maxlength="100" />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="form.contact_name" placeholder="负责人姓名" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="form.contact_phone" placeholder="负责人手机号" maxlength="11" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">微信分账（收款账户）</el-divider>
        <div class="form-tip mb8">
          供货商要能自动收到货款，必须填写微信商户号 + 商户全称，且全称要与微信支付商户平台注册的商户全称完全一致。
        </div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="商户号">
              <el-input v-model="form.wechat_merchant_no" placeholder="分账接收商户号" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户全称">
              <el-input v-model="form.wechat_merchant_name" placeholder="须与微信侧一致" maxlength="100" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">结算信息（选填，用于线下结算核对）</el-divider>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="开户银行">
              <el-input v-model="form.bank_name" placeholder="开户银行" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行卡号">
              <el-input v-model="form.bank_card_no" placeholder="银行卡号" maxlength="30" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="持卡人">
              <el-input v-model="form.bank_card_holder" placeholder="持卡人姓名" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系地址">
              <el-input v-model="form.address" placeholder="联系地址" maxlength="255" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="备注说明" maxlength="500" />
        </el-form-item>

        <template v-if="!isEdit">
          <el-divider content-position="left">后台账号（选填）</el-divider>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="登录账号">
                <el-input v-model="form.username" placeholder="供货商后台登录账号" maxlength="50" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登录密码">
                <el-input v-model="form.password" placeholder="至少6位" maxlength="50" show-password />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="form-tip">不填则不创建后台账号，后续可在「账号」里补建。</div>
        </template>

        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 供货商后台账号 -->
    <el-dialog :title="adminDialogTitle" :visible.sync="adminDialogVisible" width="900px" :close-on-click-modal="false">
      <div class="card-header mb8">
        <span class="form-tip">供货商：{{ currentDistributor.name }}</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdminCreate">新增账号</el-button>
      </div>

      <el-table :data="adminList" border stripe v-loading="adminLoading" size="small" style="width: 100%">
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="username" label="登录账号" width="140" />
        <el-table-column prop="real_name" label="姓名" width="100">
          <template slot-scope="scope">{{ scope.row.real_name || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120" />
        <el-table-column label="角色" min-width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.roles && scope.row.roles.length">
              <el-tag v-for="r in scope.row.roles" :key="r.id" size="mini" style="margin-right: 4px;">{{ r.name }}</el-tag>
            </template>
            <span v-else>超级管理员</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="last_login_time" label="最后登录" width="170" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleAdminEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #E4393C" @click="handleAdminDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        title="供货商后台账号"
        :visible.sync="adminFormVisible"
        width="480px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form ref="adminForm" :model="adminForm" :rules="adminRules" label-width="100px">
          <el-form-item label="登录账号" prop="username">
            <el-input v-model="adminForm.username" :disabled="adminIsEdit" placeholder="请输入登录账号" maxlength="50" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="adminForm.password" show-password :placeholder="adminIsEdit ? '留空则不修改' : '至少6位'" maxlength="50" />
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="adminForm.real_name" placeholder="姓名" maxlength="20" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="adminForm.phone" placeholder="手机号" maxlength="11" />
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="adminForm.role_ids" multiple placeholder="不选择则为超级管理员" style="width: 100%">
              <el-option v-for="r in roleOptions" :key="r.id" :label="r.name" :value="r.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="adminForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="adminFormVisible = false">取消</el-button>
          <el-button type="primary" :loading="adminSubmitLoading" @click="submitAdmin">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDistributors,
  createDistributor,
  updateDistributor,
  toggleDistributor,
  deleteDistributor,
  getDistributorRoles,
  getDistributorAdmins,
  createDistributorAdmin,
  updateDistributorAdmin,
  deleteDistributorAdmin
} from '@/api'

const defaultForm = {
  name: '',
  contact_name: '',
  contact_phone: '',
  wechat_merchant_no: '',
  wechat_merchant_name: '',
  bank_name: '',
  bank_card_no: '',
  bank_card_holder: '',
  address: '',
  remark: '',
  username: '',
  password: '',
  status: 1
}

export default {
  name: 'Distributors',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { page: 1, limit: 15, title: '', status: '' },
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editId: null,
      submitLoading: false,
      form: { ...defaultForm },
      rules: {
        name: [{ required: true, message: '请输入供货商名称', trigger: 'blur' }]
      },

      // 后台账号
      currentDistributor: {},
      adminDialogVisible: false,
      adminLoading: false,
      adminList: [],
      roleOptions: [],
      adminFormVisible: false,
      adminIsEdit: false,
      adminEditId: null,
      adminSubmitLoading: false,
      adminForm: {
        username: '',
        password: '',
        real_name: '',
        phone: '',
        role_ids: [],
        status: 1
      },
      adminRules: {
        username: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入至少6位密码', trigger: 'blur', min: 6 }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const params = { page: this.query.page, limit: this.query.limit }
      if (this.query.title) params.title = this.query.title
      if (this.query.status !== '' && this.query.status !== null) params.status = this.query.status

      getDistributors(params).then(res => {
        this.list = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.$message.error('获取列表失败')
      }).finally(() => { this.loading = false })
    },
    handleSearch() {
      this.query.page = 1
      this.getList()
    },
    resetFilter() {
      this.query.title = ''
      this.query.status = ''
      this.query.page = 1
      this.getList()
    },
    resetForm() {
      this.form = { ...defaultForm }
    },
    handleCreate() {
      this.isEdit = false
      this.editId = null
      this.dialogTitle = '添加供货商'
      this.resetForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑供货商'
      this.form = {
        name: row.name,
        contact_name: row.contact_name || '',
        contact_phone: row.contact_phone || '',
        wechat_merchant_no: row.wechat_merchant_no || '',
        wechat_merchant_name: row.wechat_merchant_name || '',
        bank_name: row.bank_name || '',
        bank_card_no: row.bank_card_no || '',
        bank_card_holder: row.bank_card_holder || '',
        address: row.address || '',
        remark: row.remark || '',
        username: '',
        password: '',
        status: row.status
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const data = { ...this.form }
        if (this.isEdit) {
          data.id = this.editId
          delete data.username
          delete data.password
        } else {
          if (!data.username) {
            delete data.username
            delete data.password
          }
        }

        const apiCall = this.isEdit ? updateDistributor(data) : createDistributor(data)
        apiCall.then(() => {
          this.$message.success(this.isEdit ? '保存成功' : '创建成功')
          this.dialogVisible = false
          this.getList()
        }).catch(err => {
          this.$message.error(err.message || '操作失败')
        }).finally(() => { this.submitLoading = false })
      })
    },
    handleToggleStatus(row, val) {
      toggleDistributor({ id: row.id, status: val ? 1 : 0 }).then(() => {
        this.$message.success(val ? '已启用' : '已停用')
        this.getList()
      }).catch(() => {
        this.$message.error('操作失败')
        this.getList()
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除供货商 "${row.name}"？`, '提示', { type: 'warning' }).then(() => {
        return deleteDistributor({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    },

    // ==================== 后台账号 ====================
    openAdmins(row) {
      this.currentDistributor = row
      this.adminDialogTitle = `后台账号 - ${row.name}`
      this.adminDialogVisible = true
      this.fetchRoles()
      this.fetchAdmins()
    },
    fetchRoles() {
      getDistributorRoles().then(res => {
        this.roleOptions = res.list || []
      }).catch(() => {})
    },
    fetchAdmins() {
      if (!this.currentDistributor.id) return
      this.adminLoading = true
      getDistributorAdmins({ id: this.currentDistributor.id }).then(res => {
        this.adminList = res.list || []
      }).catch(() => {
        this.$message.error('获取账号列表失败')
      }).finally(() => { this.adminLoading = false })
    },
    handleAdminCreate() {
      this.adminIsEdit = false
      this.adminEditId = null
      this.adminForm = { username: '', password: '', real_name: '', phone: '', role_ids: [], status: 1 }
      this.adminFormVisible = true
      this.$nextTick(() => {
        this.$refs.adminForm && this.$refs.adminForm.clearValidate()
        this.adminRules.password[0].required = true
      })
    },
    handleAdminEdit(row) {
      this.adminIsEdit = true
      this.adminEditId = row.id
      this.adminForm = {
        username: row.username,
        password: '',
        real_name: row.real_name || '',
        phone: row.phone || '',
        role_ids: row.role_ids || [],
        status: row.status
      }
      this.adminFormVisible = true
      this.$nextTick(() => {
        this.$refs.adminForm && this.$refs.adminForm.clearValidate()
        this.adminRules.password[0].required = false
      })
    },
    submitAdmin() {
      this.$refs.adminForm.validate(valid => {
        if (!valid) return
        this.adminSubmitLoading = true
        const data = { ...this.adminForm }
        if (this.adminIsEdit) {
          data.id = this.adminEditId
          delete data.username
          if (!data.password) delete data.password
        } else {
          data.distributor_id = this.currentDistributor.id
        }

        const apiCall = this.adminIsEdit ? updateDistributorAdmin(data) : createDistributorAdmin(data)
        apiCall.then(() => {
          this.$message.success(this.adminIsEdit ? '保存成功' : '创建成功')
          this.adminFormVisible = false
          this.fetchAdmins()
        }).catch(err => {
          this.$message.error(err.message || '操作失败')
        }).finally(() => { this.adminSubmitLoading = false })
      })
    },
    handleAdminDelete(row) {
      this.$confirm(`确认删除账号 "${row.username}"？`, '提示', { type: 'warning' }).then(() => {
        return deleteDistributorAdmin({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.fetchAdmins()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 0 16px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
.mb8 {
  margin-bottom: 8px;
}
</style>
